<template>
    <ResponsiveDialog
        :value="value"
        @input="$emit('input', $event)"
        :max-width="420"
        :full-height="false"
        :header-title="$t('journey.wildTrainerFight.title')"
        header-class="skin-window-header--wildtrainer"
        card-class="skin-card"
    >
        <div class="trainer-fight-dialog-bg skin-window--wildtrainer">
            <div class="trainer-fight-dialog-banner" :style="roadBgStyle">
                <v-img v-if="trainerImg" :src="trainerImg" contain class="trainer-fight-dialog-trainer-img"/>
            </div>
            <div class="trainer-fight-dialog-content">
                <div class="trainer-fight-dialog-message">
                    {{ trainer ? trainer.name : '' }} {{ $t('journey.wildTrainerFight.message') }}
                </div>
                <div class="trainer-fight-dialog-counts">
                    <v-btn
                        v-for="count in counts"
                        :key="count"
                        rounded
                        large
                        class="btn-shadow black--text"
                        color="accent"
                        :loading="isLoading"
                        :disabled="isLoading"
                        @click="fight(count)"
                    >
                        {{ count }}V{{ count }}
                    </v-btn>
                </div>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Trenérský souboj ve Wild - volba počtu pokémonů (1v1/2v2/3v3) jako
    // popup místo dřívějších inline tlačítek na dlaždici (Tile.vue, `isTrainer`
    // režim). Stejný bezpečný princip jako ostatní next/ dialogy (žádný SETTYPE
    // navíc, jen existující meet-trainer endpoint přes journeyApi.meetWildTrainer).
    import {mapActions, mapGetters} from 'vuex';
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
    import * as journeyApi from '@/api/journeyApi';

    export default {
        name: 'WildTrainerFightDialog',
        components: {ResponsiveDialog},
        props: {
            value: {type: Boolean, default: false},
            trainer: {type: Object, default: null},
            positionId: {type: Number, default: null},
            city: {type: Object, default: null},
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
            }),
            maxCount() {
                if (!this.trainer) {
                    return 0;
                }
                return Math.min(3, this.trainer.travellingPokemonsCount);
            },
            counts() {
                const list = [];
                for (let i = 1; i <= this.maxCount; i++) {
                    list.push(i);
                }
                return list;
            },
            // stejný obrázek jako pod trenérskou dlaždicí v gridu (WildNext.vue), mění se s městem/obtížností
            roadBgStyle() {
                return this.city ? {backgroundImage: `url(${require('@/assets/pic/roads/' + this.city.id + '.png')})`} : {};
            },
            trainerImg() {
                return this.trainer ? require('@/assets/pic/trainer/' + this.trainer.img) : '';
            },
        },
        methods: {
            ...mapActions({
                positionPost: 'journey/positionPost',
            }),
            fight(count) {
                this.positionPost(journeyApi.meetWildTrainer(this.positionId, this.trainer.id, count));
            },
        },
    }
</script>

<style scoped>
.trainer-fight-dialog-bg {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
/* pozadí řídí skin (public/skins/normal.css, .skin-window--wildtrainer) */
.trainer-fight-dialog-banner {
    /* pozadí = cesta (`cover`, jen kulisa), trenér přes ni jako samostatný
       `contain` overlay (viz .trainer-fight-dialog-trainer-img) - výška proto
       pevná/omezená (clamp 160-300px, ~33vh), ne flex-grow do celé výšky dialogu */
    position: relative;
    flex: none;
    height: clamp(160px, 33vh, 300px);
    width: 80%;
    /* margin-top nahrazuje odsazení titulku, přesunutého do ResponsiveDialog hlavičky */
    margin: 16px auto 0;
    border-radius: 16px;
    background-size: cover;
    background-position: center;
    box-shadow: 0 6px 14px rgba(0,0,0,0.3), 0 2px 5px rgba(0,0,0,0.2);
    background-color: inherit;
}
.trainer-fight-dialog-trainer-img {
    position: absolute;
    top: 8%;
    left: 0;
    width: 100%;
    height: 84%;
    filter: drop-shadow(2px 3px 5px rgba(0,0,0,0.6));
}
.trainer-fight-dialog-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 28px 20px 86px 20px;
}
.trainer-fight-dialog-message {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
}
.theme--light .trainer-fight-dialog-message {
    color: rgba(0,0,0,0.8);
}
.theme--dark .trainer-fight-dialog-message {
    color: rgba(255,255,255,0.85);
}
.trainer-fight-dialog-counts {
    display: flex;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
}
</style>
